import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";

@Injectable()
export class AssignTestService {
  constructor(private http: HttpClient) { }
  getPersonTestList(personId): Observable<Object> {
    return this.http.get(`/api/InternalPersonTest/getPersonTestList`, {
      params: { PERSON_ID: personId },
      responseType: "json",
      observe: "response"
    });
  }
  getTestDetails(testDateId): Observable<Object> {
    return this.http.get(`/api/InternalPersonTest/getTestDetails`, {
      params: { TEST_DATE_ID: testDateId },
      responseType: "json",
      observe: "response"
    });
  }
  unassignTestAdministration(data) {
    return this.http.put(
      `/api/InternalPersonTest/unAssignTestAdministration`,
      data,
      {
        observe: "response"
      }
    );
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accomsupport/service/assign-test.service.ts